// extracted by mini-css-extract-plugin
module.exports = {"OrderInfo":"ReviewLink_OrderInfo__vU6hc","UploadInfo":"ReviewLink_UploadInfo__1EYAK"};